var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clock-hand",style:({
  transform: 'rotate('+_vm.deg+'deg)',
  height: _vm.length + 'px',
  width: _vm.weight + 'px',
  top: 'calc(50% - '+_vm.length+'px)'
})})}
var staticRenderFns = []

export { render, staticRenderFns }